export default Object.freeze({
  AUTHN_WORKFLOWS: {
    AUTHORIZE: 'Authorize',
    FHIRAUTHORIZE: 'FhirAuthorize',
    AUTHORIZEVIAIDP: 'AuthorizeViaIDP',
    MANAGEPROFILE: 'ManageProfile',
  },
});
